import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Range } from './Range';
import { FacetSelectFilter, SelectFilter } from './SelectFilter';
import { Text } from './Text';
import { jsx as _jsx } from "react/jsx-runtime";
var filterComponents = {
  range: function range(_ref) {
    var column = _ref.column,
        isDisabled = _ref.isDisabled;
    return /*#__PURE__*/_jsx(Range, {
      column: column,
      isDisabled: isDisabled,
      e2eid: "Filter_ColumnFilter_Range"
    });
  },
  text: function text(_ref2) {
    var column = _ref2.column,
        isDisabled = _ref2.isDisabled;
    return /*#__PURE__*/_jsx(Text, {
      column: column,
      isDisabled: isDisabled,
      e2eid: "Filter_ColumnFilter_Text"
    });
  },
  select: function select(_ref3) {
    var column = _ref3.column,
        isDisabled = _ref3.isDisabled;
    var columnMeta = column.columnDef.meta;
    var selectFilterProps = columnMeta.selectFilterProps;
    return selectFilterProps ? /*#__PURE__*/_jsx(SelectFilter, _objectSpread(_objectSpread({
      className: "w-full",
      column: column,
      isDisabled: isDisabled
    }, selectFilterProps), {}, {
      e2eid: "Filter_ColumnFilter_SelectFilter"
    })) : /*#__PURE__*/_jsx(FacetSelectFilter, {
      className: "w-full",
      column: column,
      e2eid: "Filter_ColumnFilter_FacetSelectFilter"
    });
  }
};
export function ColumnFilter(_ref4) {
  var column = _ref4.column,
      isDisabled = _ref4.isDisabled;
  var columnMeta = column.columnDef.meta;
  var Component = columnMeta !== null && columnMeta !== void 0 && columnMeta.filterVariant ? filterComponents[columnMeta.filterVariant] : null;
  if (!Component) return null;
  return /*#__PURE__*/_jsx(Component, {
    column: column,
    isDisabled: isDisabled,
    e2eid: "Filter_ColumnFilter_Component"
  });
}